export default __webpack_public_path__ + "static/media/purplebgsmall.1d46b34b.svg";